import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PropertyCard = ({ property, onEdit, onViewAnalytics, onManageInquiries }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-success bg-green-50';
      case 'pending': return 'text-warning bg-yellow-50';
      case 'inactive': return 'text-error bg-red-50';
      default: return 'text-text-secondary bg-muted';
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="bg-surface rounded-lg border border-border shadow-property-card hover:shadow-modal transition-smooth">
      <div className="relative">
        <div className="h-48 overflow-hidden rounded-t-lg">
          <Image
            src={property.images[0]}
            alt={property.title}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute top-3 left-3">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(property.status)}`}>
            {property.status.charAt(0).toUpperCase() + property.status.slice(1)}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className="bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
            {property.images.length} photos
          </span>
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="text-lg font-semibold text-text-primary line-clamp-1">
            {property.title}
          </h3>
          <Button
            variant="ghost"
            size="sm"
            iconName="MoreVertical"
            onClick={() => onEdit(property.id)}
          />
        </div>

        <div className="flex items-center text-text-secondary text-sm mb-2">
          <Icon name="MapPin" size={14} className="mr-1" />
          <span className="line-clamp-1">{property.location}</span>
        </div>

        <div className="flex items-center justify-between mb-3">
          <div className="text-xl font-bold text-primary">
            {formatCurrency(property.price)}
            <span className="text-sm font-normal text-text-secondary">
              {property.type === 'rent' ? '/month' : ''}
            </span>
          </div>
          <div className="text-sm text-text-secondary">
            {property.bedrooms}BHK • {property.area} sq ft
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mb-4 text-center">
          <div>
            <div className="text-lg font-semibold text-text-primary">{property.views}</div>
            <div className="text-xs text-text-secondary">Views</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-text-primary">{property.inquiries}</div>
            <div className="text-xs text-text-secondary">Inquiries</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-text-primary">{property.favorites}</div>
            <div className="text-xs text-text-secondary">Saved</div>
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="BarChart3"
            iconPosition="left"
            onClick={() => onViewAnalytics(property.id)}
            className="flex-1"
          >
            Analytics
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="MessageSquare"
            iconPosition="left"
            onClick={() => onManageInquiries(property.id)}
            className="flex-1"
          >
            Inquiries ({property.newInquiries})
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;